module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/300-schools-6e851051904ac8841c88cd8bdb39391b.svg";